import { EAuthUserPlatformType } from '../../../../types/rest/IRestAuthUser';
import { IApplicationState } from '../../../../types/types';
import { getAuthUser } from './getAuthUser';

export const getAuthUserPlatformType = (
    state: IApplicationState
): EAuthUserPlatformType => {
    return getAuthUser(state).platformType || EAuthUserPlatformType.GOOGLE;
}
